<template>
  <span
    class="battery"
    v-bind:style="{'box-shadow': ' inset 0 -' + fill + 'px 0px '+fillColor, 'border-color':fillColor}"
    v-bind:data-percentage="convertedPercentage + '%'"
  ></span>
</template>
<script>
export default {
  name: "DeviceBattery",
  props: ["percentage"],
  data() {
    return {};
  },
  computed: {
    fill() {
      if (this.percentage === 0) {
        return 0;
      } else {
        return (this.percentage / 100) * 14;
      }
    },
    fillColor() {
      if (this.percentage > 75) return "green";
      if (this.percentage > 50) return "orange";
      if (this.percentage > 0) return "red";
	},
	convertedPercentage() {
		return this.percentage.toFixed(0);
	}
  }
};
</script>
<style lang="scss" scoped>
.battery {
  width: 8px;
  height: 16px;
  border-style: solid;
  border-width: 1px;
  display: inline-block;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;

  &:before {
    content: attr(data-percentage);
    position: absolute;
    width: 100%;
	text-align: center;
    font-size: 8px;
	bottom: -15px;
	left: -10%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Units/DeviceBattery.vue